"use strict";
exports.__esModule = true;
var fetch_1 = require("./utils/fetch");
function prepareParams(params) {
    var baseUrl = params['baseUrl'] || '/';
    var query = Object.assign({}, params);
    delete query['baseUrl'];
    return {
        baseUrl: baseUrl,
        query: query
    };
}
var requests = {
    home: function (params) {
        var _a = prepareParams(params), baseUrl = _a.baseUrl, query = _a.query;
        return fetch_1.memoizedFetch({
            url: baseUrl + 'cian-api/site/v1/adfox/home/',
            query: query
        });
    },
    offer: function (params) {
        var _a = prepareParams(params), baseUrl = _a.baseUrl, query = _a.query;
        return fetch_1.memoizedFetch({
            url: baseUrl + 'cian-api/site/v1/adfox/offer',
            query: query
        });
    },
    search: function (params) {
        var _a = prepareParams(params), baseUrl = _a.baseUrl, query = _a.query;
        return fetch_1.memoizedFetch({
            url: baseUrl + 'cian-api/site/v1/adfox/search/',
            method: 'POST',
            params: query
        });
    },
    test: function (params) {
        // tslint:disable-next-line:no-any
        return Promise.resolve({
            body: {
                data: {
                    params: {
                        puid5: 'obl_id_1',
                        puid2: 'offer_flat',
                        puid1: 'deal_type_rent',
                        puid10: 'no_agent'
                    }
                }
            }
        });
    }
};
var bannerToRequestMap = {
    apps: requests.home,
    new_buildings: requests.home,
    parallax_in_offers_list: requests.offer,
    parallax_in_offers_list_map: requests.offer,
    tgb_in_offers_list: requests.offer,
    tgb_in_card: requests.offer,
    credit_or_mortgage: requests.offer,
    test_banner: requests.test,
    mortgage_offer_card_banner: requests.offer
};
function fetchTargets(type, params) {
    if (params === void 0) { params = {}; }
    var request = bannerToRequestMap[type];
    if (!request) {
        throw new Error("No request for banner type \"" + type + "\" specified");
    }
    return request(params)
        .then(function (res) {
        return res.body.data.params;
    })["catch"](function (err) {
        console.error('Failed to get targets', err);
        throw err;
    });
}
exports.fetchTargets = fetchTargets;
//# sourceMappingURL=api.js.map